// src/pages/Register.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Auth.css';
import swal from 'sweetalert2';

const Register = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    company: '',
    terms: false
  });
  const [message, setMessage] = useState('');


  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  
  const validateForm = () => {
    if (!formData.name) {
      setError('El nombre es obligatorio');
      return false;
    }
    
    if (!formData.email) {
      setError('El correo electrónico es obligatorio');
      return false;
    }
    
    if (!formData.password) {
      setError('La contraseña es obligatoria');
      return false;
    }
    
    if (formData.password.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres');
      return false;
    }
    
    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      return false;
    }
    
    if (!formData.company) {
      setError('El nombre de la empresa es obligatorio');
      return false;
    }
    
    if (!formData.terms) {
      setError('Debes aceptar los términos y condiciones');
      return false;
    }
    
    return true;
  };
  

const handleRegister = async (e) => {
  e.preventDefault();
    
  if (!validateForm()) {
    return;
  }

  try {
    const formDataToSend = new FormData();
    formDataToSend.append('password', formData.password);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('name', formData.name);
    formDataToSend.append('company', formData.company);
    if (formData.vat) {
      formDataToSend.append('vat', formData.vat);
    }
    
    console.log('Form data being sent:');
    for (let pair of formDataToSend.entries()) {
      console.log(pair[0] + ': ' + pair[1]);
    }
    
    //const response = await fetch('https://f93f4894-6fc1-43f3-8b6c-c61b254b6fc4.clouding.host/api/register', {
    const response = await fetch('https://85583adb-06b4-41dd-839f-241c1405c5ae.clouding.host/api/register', {
      method: 'POST',
      body: formDataToSend,
      headers: {
        'Accept': 'application/json',
      }
    });
    console.log('response')
    console.log(response)

    const data = await response.json();
    console.log(data)

    
    if (data.status === 'success') {
      localStorage.setItem('user_info', JSON.stringify(data.user_info)); // Store user info

      localStorage.setItem('providers', JSON.stringify(data.providers));
      localStorage.setItem('bots', JSON.stringify(data.bots));
      localStorage.setItem('connections', JSON.stringify(data.connections));
      localStorage.setItem('templates', JSON.stringify(data.flussi));

    swal({
  title: "Registración Exitosa",
  text: "Serás redirigido a la tienda.",
  icon: "success",
  buttons: {
    confirm: {
      text: "OK",
      value: true,
      visible: true,
      className: "",
      closeModal: true
    }
  }
}).then((value) => {
  if (value) {
    window.location.href = '/shop-grid-standard';
  }
});
     
     } else {

      setMessage('Errore di registrazione');
    }
  } catch (error) {

    setMessage('Registration failed');
  }
};
const contras = ()=>{
  if (false){
    swal({
    title: "Restrablecer contraseña",
    text: "Por favor envía un correo a: compras@bep.es para recuperar tu contraseña",
    icon: "info",
    buttons: {
      confirm: {
        text: "OK",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }
  })}else{
      // SweetAlert with email input and reset button
// SweetAlert with email input and reset button
swal({
  title: "Restablecer contraseña",
  text: "Introduce tu correo electrónico para recuperar tu contraseña",
  icon: "info",
  content: {
    element: "input",
    attributes: {
      placeholder: "Correo electrónico",
      type: "email",
    },
  },
  buttons: {
    cancel: {
      text: "Cancelar",
      value: null,
      visible: true,
      className: "",
      closeModal: true
    },
    reset: {
      text: "Restablecer",
      value: true,
      visible: true,
      className: "swal-button--reset",
      closeModal: false
    }
  }
}).then((value) => {
  if (value) {
    const email = document.querySelector(".swal-content__input").value;
    if (!email || !email.includes('@')) {
      swal({
        title: "Error",
        text: "Por favor introduce un correo electrónico válido",
        icon: "error",
        button: "OK"
      });
      return;
    }
    
    // Post to Odoo reset password API endpoint
    fetch('https://f93f4894-6fc1-43f3-8b6c-c61b254b6fc4.clouding.host/api/rstpwd/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ user: email }),
    })
    .then(response => response.json())
    .then(data => {
        swal({
          title: "Contraseña restablecida",
          text:"Si existe un usuario correspondenre recibirá una  ueva contraseña en el correo",
          icon: "success",
          button: "OK"
        });
      
    })
    .catch((error) => {
      swal({
        title: "Error de conexión",
        text: "Hubo un problema al procesar tu solicitud. Por favor intenta más tarde.",
        icon: "error",
        button: "OK"
      });
    });
  }
});

    }

}
  return (
    <div className="auth-container">
      <div className="auth-card register-card">
        <div className="auth-header">
          <div className="auth-logo">
            <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="#3182ce" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <path d="M8 14s1.5 2 4 2 4-2 4-2" />
              <line x1="9" y1="9" x2="9.01" y2="9" />
              <line x1="15" y1="9" x2="15.01" y2="9" />
            </svg>
          </div>
          <h1>Notto Bot Manager</h1>
          <p>Crea una nueva cuenta</p>
        </div>
        
        {error && (
          <div className="auth-error">
            {error}
          </div>
        )}
        
        <form onSubmit={handleRegister} className="auth-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Nombre Completo</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Tu nombre completo"
                autoComplete="name"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="company">Empresa</label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder="Nombre de tu empresa"
                autoComplete="organization"
              />
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="correo@empresa.com"
              autoComplete="email"
            />
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="password">Contraseña</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Mínimo 8 caracteres"
                autoComplete="new-password"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirmar Contraseña</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="Confirma tu contraseña"
                autoComplete="new-password"
              />
            </div>
          </div>
          
          <div className="terms-checkbox">
            <input
              type="checkbox"
              id="terms"
              name="terms"
              checked={formData.terms}
              onChange={handleChange}
            />
            <label htmlFor="terms">
              Acepto los <Link to="/terms" target="_blank" rel="noopener noreferrer">Términos y Condiciones</Link> y la <Link to="/privacy" target="_blank" rel="noopener noreferrer">Política de Privacidad</Link>
            </label>
          </div>
          
          <button
            type="submit"
            className="auth-button"
            disabled={isLoading}
          >
            {isLoading ? 'Creando cuenta...' : 'Crear Cuenta'}
          </button>
        </form>
        
        <div className="auth-footer">
          <p>¿Ya tienes una cuenta? <Link to="/login">Inicia sesión</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Register;